import {
  VideoCameraIcon,
  DocumentTextIcon,
  MicrophoneIcon,
  PhotoIcon,
  LinkIcon,
} from "@heroicons/react/24/outline";
import { PropsWithoutRef, ReactNode, SVGProps } from "react";
export enum ResourceType {
  HTML = "html",
  PDF = "pdf",
  IMAGE = "image",
  VIDEO = "video",
  AUDIO = "audio",
  NOTE = "note",
}
export const getResourceIcon = (
  type: ResourceType,
  state: string,
): ((props: PropsWithoutRef<SVGProps<SVGSVGElement>>) => ReactNode | null) => {
  if (state === "error") {
    return LinkIcon;
  }
  switch (type) {
    case ResourceType.VIDEO:
      return VideoCameraIcon;
    case ResourceType.HTML:
    case ResourceType.PDF:
    case ResourceType.NOTE:
      return DocumentTextIcon;
    case ResourceType.AUDIO:
      return MicrophoneIcon;
    case ResourceType.IMAGE:
      return PhotoIcon;

    default:
      return LinkIcon;
  }
};
import defaultArticle from "~/assets/default_article.png";
import defaultNote from "~/assets/default_note.png";
import defaultVideo from "~/assets/default_video.png";
import defaultAudio from "~/assets/default_audio.png";
import defaultError from "~/assets/default_article_error.png";

const articleTypeToImage = {
  html: defaultArticle,
  pdf: defaultArticle,
  note: defaultNote,
  video: defaultVideo,
  audio: defaultAudio,
  image: defaultArticle,
  course: defaultArticle,
} as { [key: string]: string };
export function getDefaultArticleImage(
  imageUrl: string,
  type: string,
  state: string,
): string {
  try {
    new URL(imageUrl);
    return imageUrl;
  } catch {
    if (state === "error") {
      return defaultError;
    }
    const image = articleTypeToImage[type];
    return image ? image : articleTypeToImage.html;
  }
}
